
export default {
  updateThemeColor: (state, color) => {
    state.themeColor = color
  },
  changeLanguage: (state, language) => {
    state.locale = language
    localStorage.setItem('lang', language)
  },
  updateNotificationCount: (state, count) => {
    state.notificationCount = count
  },
  updateTrainInfo: (state, trainInfo) => {
    state.trainInfo = trainInfo
  }
}
